// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .chat-container {
  display: flex;
  flex-direction: column;
  height: 500px;
  width: 400px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow: hidden;
  background: #f4f4f4;
} */

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 0px 20px;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
}

.message {
  width: 360px;
  padding: 20px;
  margin: 5px 0;
  white-space: pre-wrap;
  font-family: "McKinseySans-Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.user {
  align-self: flex-end;
  color: white;
  border-radius: 10px 10px 0px 10px;
  background: #2b5580;
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.15);
}

.bot {
  align-self: flex-start;
  color: #082644;
  border-radius: 4px 20px 20px 20px;
  background: #fff;
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.1);
}
.icon-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.msg-source {
  font-family: "McKinseySans-Regular", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-bottom: 0.5rem;
}

.msg-source-user {
  align-self: flex-end;
  color: #1b456e;
}

.msg-source-bot {
  align-self: flex-start;
  color: #7f7f7f;
}
.img-button {
  background: none;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;;AAEH;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* .chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 500px;\n  width: 400px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  overflow: hidden;\n  background: #f4f4f4;\n} */\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0px 20px;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 1rem;\n}\n\n.message {\n  width: 360px;\n  padding: 20px;\n  margin: 5px 0;\n  white-space: pre-wrap;\n  font-family: \"McKinseySans-Regular\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.user {\n  align-self: flex-end;\n  color: white;\n  border-radius: 10px 10px 0px 10px;\n  background: #2b5580;\n  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.15);\n}\n\n.bot {\n  align-self: flex-start;\n  color: #082644;\n  border-radius: 4px 20px 20px 20px;\n  background: #fff;\n  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.1);\n}\n.icon-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n.msg-source {\n  font-family: \"McKinseySans-Regular\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  padding-bottom: 0.5rem;\n}\n\n.msg-source-user {\n  align-self: flex-end;\n  color: #1b456e;\n}\n\n.msg-source-bot {\n  align-self: flex-start;\n  color: #7f7f7f;\n}\n.img-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
